export interface ResultadoEtapa {
  semana: string;
  titulo: string;
  descripcion: string;
}

export const resultadosEsperados: ResultadoEtapa[] = [
  {
    semana: 'Semana 1',
    titulo: 'Línea base',
    descripcion: 'Empezás a registrar cómo te sentís hoy: sabés exactamente de dónde partís.'
  },
  {
    semana: 'Semana 4',
    titulo: 'Primeros cambios',
    descripcion: 'La hinchazón baja notablemente y la energía empieza a mejorar.'
  },
  {
    semana: 'Semana 8',
    titulo: 'Cambio visible',
    descripcion: 'Notás la ropa más cómoda, mejor descanso y más constancia en el día a día.'
  },
  {
    semana: 'Semana 12',
    titulo: 'Transformación real',
    descripcion: 'Resultados sostenidos y la confianza en tu cuerpo, de vuelta.'
  }
];
